<template>
  <el-container>
    <el-header class="operation">
      <div class="nav">
        <img @click="resolvePath('/editMaterials')" style="width: 40px;height:40px;position:relative;right:0px;top:15px;border-radius: 75%" :src="userInfo.photo" alt="">
        <span @click="resolvePath('/editMaterials')" style="  margin-left: 10px;">{{userInfo.user_name}}</span>
<!--        <span>前台首页</span>-->
<!--        <span  style="cursor : pointer;" @click="backstage">后台首页</span>-->
<!--        <span>清除缓存</span>-->
        <span style="cursor : pointer;" @click="signout">退出管理</span>
      </div>
      <!--        <el-dropdown>-->
      <!--          <i class="el-icon-setting" style="margin-right: 15px"></i>-->
      <!--          <el-dropdown-menu slot="dropdown">-->
      <!--            <el-dropdown-item>查看</el-dropdown-item>-->
      <!--            <el-dropdown-item>新增</el-dropdown-item>-->
      <!--            <el-dropdown-item>删除</el-dropdown-item>-->
      <!--          </el-dropdown-menu>-->
      <!--        </el-dropdown>-->
      <!--        <span>王小虎</span>-->
    </el-header>
  </el-container>
</template>

<script>
  export default {
    name: 'Head',
    data() {
      return {
        userInfo:''
      }
    },
    created:function(){
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    },
    methods:{
      signout(){
        localStorage.removeItem('user-token');
        this.$message({
          message: '退出成功',
          type: 'success'
        });
        this.$router.push('/login');
      },
      backstage(){
        this.$router.push('/');
      },
      resolvePath(routePath) {
        this.$router.push(routePath);
      },
    }
  }
</script>

<style lang="less">

.el-submenu__title{
  color:white;
}
.copyright span{
  color:white;
  font-size: 14px;
  margin-left: 20px;
}
.copyright{
  float: left;
  display: inline-block;
}
.operation{
  text-align: right;
  display: inline-block;
  font-size: 12px
}
.nav span{
  color:white;
  font-size: 14px;
  margin-left: 20px;
}
.aside{
  width:200px;
  background-color: #304156;
}
.elContainer{
  position:relative;
  left:0px;
  top:0px;
  height:100vh;
  border: 0px solid #eee
}
.admin{
  position: relative;
  height: 60px;
  line-height: 60px;
}
.admin .adminName{
  padding-left: 75px;
  margin-left: 10px;
}
.admin .adminImg{
  position: absolute;
  margin-left: 30px;
  margin-top: 10px;
  float:left;
}
.admin .adminImg img{
  border-radius: 30px;
  width: 40px;
  height: 40px;
}
.websiteName{
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 24px;
  color: white;
  font-weight: normal;
}
.el-header {
  z-index: 1000;
  background-color: #2c809f;
  color: #333;
  line-height: 60px;
}
.el-submenu__title:hover {
  background-color: #409eff;
}
.el-menu{
  border: solid 1px #304156;
  color:white;
  background-color: #304156;
}
.el-aside {
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/Layout/components/HeadBlock.vue